import ReactDOM from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import allReducer from './redux/reducers'
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import packageJson from '../package.json'
import Index from './Components/Home/index'
import { getAppName, getLogo } from './hooks/useBrandConfig'
import { isSupportedBrowser, isPlayViewerPath } from './utils/browserSupport'

import { BrowserRouter, HashRouter } from 'react-router-dom'
import history from './utils/history'
import * as atatus from 'atatus-spa'
import { DBConfig } from './Components/AppMode/DBConfig'
import { initDB } from 'react-indexed-db'
// The block-based editor runs on a different port, so it syncs variant
// changes back via a cookie instead of sessionStorage. Read it here before
// anything mounts so the first render is already up to date.
;(function syncPeeCeeVariantFromBlockBased() {
    const match = document.cookie.match(/(?:^|; )peeCeeVariantSync=([^;]+)/)
    if (!match) return
    const variant = match[1] === '2' ? '2' : '1'
    sessionStorage.setItem('peeCeeConfVersion', variant)
    sessionStorage.setItem(
        'allowedPeeCeeVariant',
        variant === '2' ? 'ted2' : 'ted1'
    )
    document.cookie = 'peeCeeVariantSync=; path=/; max-age=0'
})()

const favicon = getLogo('favicon')
if (!packageJson['dev']) {
    console.log = function () {}
    console.warn = function () {}
    atatus.config('79c22e4b82f14c579a891b4995165a75').install()
}

const store = createStore(
    allReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 })
)

document.title = getAppName() + ' App'
document.querySelector("link[rel='apple-touch-icon']").href = favicon
document.querySelector("link[rel='icon']").href = favicon
// Render the full app for supported (Chromium) browsers, or — on any browser —
// when opening a standalone Play viewer route (playdynamex / playmex), which is
// content-only and doesn't need hardware/WebSerial.
const supportedBrowser =
    isSupportedBrowser() || isPlayViewerPath(window.location.pathname)

initDB(DBConfig)

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            {/* <React.StrictMode> */}
            {/* {isMobile
        ? 
        window.alert(
            "If you would like to connect the hardware kindly use this website on a Desktop/Laptop or download the Plode App from the PlayStore/AppStore"
          )
        : null}{" "} */}
            {supportedBrowser ? <App></App> : <Index></Index>}

            {/* </React.StrictMode> */}
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
